// material
import {Box, Container, Grid, Typography} from "@mui/material";
// mantenedorAdmin
import CarouselTestimoniales from "./CarouselTestimoniales";
import CarouselSkeleton from "../skeletons/CarouselSkeleton";
import useGetTestimonials from "../../../hooks/portal/useGetTestimonials";

export default function Testimonials() {
  const {testimonials, loading} = useGetTestimonials()

  return (
    <Box sx={{ py: { xs: 5, md: 10 } }}>
      <Typography variant="h2" align="center" sx={{ mb: 2 }}>
        Testimoniales
      </Typography>
      <Container>
        {
          testimonials.length > 0 && !loading &&
          <CarouselTestimoniales arr={testimonials}/>
        }
        {
          loading &&
          <Grid container spacing={4}>
            {
              [...Array(2)].map((item, index) => (
                <Grid item xs={12} sm={6} key={index + 1}>
                  <CarouselSkeleton />
                </Grid>
              ))
            }
          </Grid>
        }
      </Container>
    </Box>
  );
}
